export default __webpack_public_path__ + "static/media/supplier_products.e6e96814.svg";